/* tslint:disable */
/* eslint-disable */
export enum TargetGroupEnum {
  NotSet = 0,
  YoungWoman = 1,
  OldWoman = 2,
  YoungMan = 3,
  OldMan = 4
}
